import React from "react";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import { getUserAbbreviation, getUserDisplayName, getUserEmail, userNameToColor } from "~/cores/userCore";
import { CopyOnClick } from "../copyText/CopyOnClick.jsx";
import { CopyClickableIcon } from "../copyText/CopyClickableIcon.jsx";

const SIZES = {
    small: {
        width: "20px",
        fontSize: "8px",
    },
    medium: {
        width: "28px",
        fontSize: "11px",
    },
    large: {
        width: "35px",
        fontSize: "13px",
    },
};

export function UserAvatarFullInfo({ user, size }) {
    return (
        <div style={{ display: "flex", gap: "20px" }}>
            <UserAvatarCircleOnly user={user} size={size} />
            <div>
                <div
                    style={{
                        display: "flex",
                        gap: "40px",
                        // alignItems: "center",
                    }}
                >
                    <div style={{ fontSize: "13px" }}>{getUserDisplayName({ user })}</div>
                    {/*<div*/}
                    {/*    style={{*/}
                    {/*        color: COLORS.WEAK_TEXT,*/}
                    {/*        fontSize: "12px",*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {getReadableUserType({ user })}*/}
                    {/*</div>*/}
                </div>
                <div className={"muted"} style={{ fontSize: "12px", marginTop: "5px" }}>
                    <CopyClickableIcon text={getUserEmail({ user })} />
                </div>
            </div>
        </div>
    );
}

export function UserAvatarCircleOnly({ user, size = "medium" }) {
    const sizes = SIZES[size];

    const width = sizes?.width;
    const fontSize = sizes?.fontSize;
    return (
        <div
            style={{
                borderRadius: "40px",
                width: width,
                height: width,
                fontSize: fontSize,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                background: userNameToColor({ user }),
            }}
        >
            {getUserAbbreviation({ user })}
        </div>
    );
}

export default function UserAvatar(props) {
    const { user, size = "medium" } = props;

    return (
        <TurnrTooltip content={<UserAvatarFullInfo user={user} />}>
            <CopyOnClick text={getUserEmail({ user })} copiedText={"Email copied!"}>
                <UserAvatarCircleOnly user={user} size={size} />
            </CopyOnClick>
        </TurnrTooltip>
    );
}
